const htmlContent = `
<div id="markdown">
<h1 id="der-rclone-befehl-mit-der-ionos-cloud">Der Rclone-Befehl mit der Ionos Cloud</h1>
<p>Hier eine funktionierende rclone.conf für S3 in der Ionos Cloud (ehemals: ProfitBricks).</p>
<p>Ich habe einige Zeit gebraucht, um diese Einstellungen zu finden, da
die Anleitung unter <a href="https://www.ionos.de/digitalguide/server/knowhow/datenmigration-mit-rclone/">https://www.ionos.de/digitalguide/server/knowhow/datenmigration-mit-rclone/</a>
nicht wirklich weitergeholfen hat.</p>
<pre><code>[ionos]
type = s3
provider = Other
env_auth = true
access_key_id = ********************
secret_access_key = ****************************************
endpoint = https://s3-de-central.profitbricks.com:443
acl = private
</code></pre>
<p>Ersetzen Sie die Sternchen durch Ihre Zugangsdaten.  </p>
<h2 id="ein-reales-anwendungsbeispiel">Ein reales Anwendungsbeispiel</h2>
<p>Im folgenden Skript
wird der komplette Bucket <code>g1-fileshare</code> mit dem lokalen Verzeichnis <code>g1-fileshare</code> synchronisiert.</p>
<pre><code>#!/bin/bash

set -eu

DIR=&quot;\$( cd &quot;\$( dirname &quot;\${BASH_SOURCE[0]}&quot; )&quot; &amp;&amp; pwd )&quot;
pushd \$DIR

rclone \
  --config \$(realpath rclone.conf ) \
  sync ionos:g1-fileshare/ g1-fileshare/
</code></pre>

</div>
`;
export default htmlContent
